// extracted by mini-css-extract-plugin
export default {"box":"e2SY5mg3jxbKa1icwnZb","clientFee":"RqfiZRWwwPD2W2uCOgWE","description":"VjAQYQE1Rr2V9977zafZ","extraInfoRow":"SwxPhGSJLhtynLro0dof","totalRow":"ydO8JO2u1KA_rg_zqEpi"};